import {requestContext} from '../../common/requestContext';
import {UserAndCashQueryVariables} from '../../graphql/generated/types';

export function shouldFetchAccount(
  variables?: UserAndCashQueryVariables
): boolean {
  if (variables?.authInput?.accessToken || variables?.authInput?.appUserId) {
    return true;
  }

  const requestInfo = requestContext.requestInfo;

  return Boolean(requestInfo?.user || requestInfo?.kakaoAuth?.accessToken);
}
